import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GiftConfirmationService {
  apiName = 'Default';
  

  confirmDelivery = (giftId: string, messageToFan: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/app/gift-confirmation/confirm-delivery/${giftId}`,
      params: { messageToFan },
    },
    { apiName: this.apiName,...config });
  

  confirmDeliveryFromEmail = (giftId: string, codeConfirm: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/app/gift-confirmation/confirm-delivery-from-email/${giftId}`,
      params: { codeConfirm },
    },
    { apiName: this.apiName,...config });
  

  confirmDeliveryMany = (giftIds: string[], messageToFan: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/gift-confirmation/confirm-delivery-many',
      params: { messageToFan },
      body: giftIds,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
